import React from 'react'
import PropTypes from 'prop-types'
import { LoadingSpinner } from '../../components'
import { Button } from 'react-bootstrap'

const SaveBar = props => {
  const spinner = (
    <LoadingSpinner innerClass="ContentManager_SaveSpinner text-white" />
  )
  return (
    <Button
      variant="warning"
      disabled={props.saving}
      onClick={props.handleSave}
      className="pull-right"
    >
      {props.saving ? spinner : 'Save Order'}
    </Button>
  )
}
SaveBar.propTypes = {
  saving: PropTypes.bool.isRequired,
  handleSave: PropTypes.func.isRequired,
}

export default SaveBar
